module.exports = __webpack_public_path__ + "static/img/AMac.c7c868d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/AMac.png
// module id = I7eI
// module chunks = 3